import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AngularI18nService, Section } from 'common/data/i18n/services/angular-i18n.service';

@Injectable({ providedIn: 'root' })
export class TranslationsResolver implements Resolve<void> {
    public constructor(private readonly i18n: AngularI18nService) {}

    public resolve(route: ActivatedRouteSnapshot): Observable<void> {
        const sections: Array<Section> = route.data['i18nSections'] ?? [];
        if (sections.length === 0) {
            return of(undefined);
        }

        return forkJoin(sections.map((s: Section) => this.i18n.loadSectionAsync(s))).pipe(
            map((): void => undefined),
            catchError((): Observable<void> => of(undefined)),
        );
    }
}

// Helper to build route data + resolver in one call
export function withTranslations(...sections: Array<Section>): {
    resolve: { translations: typeof TranslationsResolver };
    data: { i18nSections: Array<Section> };
} {
    return {
        resolve: { translations: TranslationsResolver },
        data: { i18nSections: sections },
    };
}
